export default __webpack_public_path__ + "static/media/GR00052-owl_0.1270809a.svg";